import React from "react";

export default function footer() {
    return (
        <footer>
            <p>Built by <a href="https://alexandrestang.com/">Alexandre Stang</a> | Powered by <a
                href="https://www.themoviedb.org/">TheMovieDB</a></p>
        </footer>
    )
}